import { getExplainVal, getTips } from '@/pages/dashboard/utils/getExplainVal';
import { getLocale, useSelector } from 'umi';

export type TRainbowItem = {
  key: string;
  explainEn?: string;
  explainCn?: string;
}

export type TRainbow = {
  tipText: string;
  tipEn: string;
  tipCn: string;
}

type TUseStudioExplainFn = <T extends string | TRainbowItem[]>(
  // 指标七彩石key
  rainbowKeys: T,
  // 自定义中英文注释, 只针对单个指标起效
  explainEn?: string,
  explainCn?: string,
) => T extends string ? TRainbow : { [key: string]: TRainbow; };

// 根据传入指标key获取对应的注释
const useStudioExplain: TUseStudioExplainFn = (
  rainbowKeys,
  explainEn,
  explainCn
) => {
  const explainInfo = useSelector((state: any) => state.studio?.explainInfo);

  if (Array.isArray(rainbowKeys)) {
    const explainObj: {
      [key: string]: TRainbow;
    } = {};

    rainbowKeys?.forEach((item) => {
      const { key, explainEn: itemExplainEn, explainCn: itemExplainCn } = item;
      if (key) {
        explainObj[key] =
        {
          tipText: getExplainVal(explainInfo, key, getLocale(), itemExplainEn, itemExplainCn),
          ...(getTips(explainInfo, key, itemExplainEn, itemExplainCn) || {})
        };
      }
    });

    return explainObj;
  }

  return {
    tipText: getExplainVal(explainInfo, rainbowKeys, getLocale(), explainEn, explainCn),
    ...(getTips(explainInfo, rainbowKeys, explainEn, explainCn) || {})
  } as any;
};

export default useStudioExplain;
